import { getLinkAriaLabel } from '@/utils/urlUtils';

import type { ContentfulNavQuickLinksFragment } from '@/graphql/contentful/api';
import { useRegionProvider } from '@/providers/RegionProvider';

import * as S from './HistoryNavigations.styles';

export const HistoryNavigations = ({
  linksCollection,
}: ContentfulNavQuickLinksFragment) => {
  const { locale } = useRegionProvider();
  const isSpaceBetween = (linksCollection?.items?.length ?? 0) > 1;
  return (
    <S.Wrapper
      $isSpaceBetween={isSpaceBetween}
      test-dataid='HistoryNavigationWrapper'
    >
      {linksCollection?.items.map((item) => {
        const itemUrl = item?.url && item.url !== '#' ? item.url : undefined;
        return (
          <S.Navigations key={item?.sys.id}>
            <S.NavigationsTitle className='NavigationsTitle'>
              {item?.topLabelText}
            </S.NavigationsTitle>
            <S.LinksBox $isSpaceBetween={isSpaceBetween} className='LinksBox'>
              <S.Links
                aria-label={
                  itemUrl
                    ? getLinkAriaLabel(itemUrl, locale.code) ||
                      item?.urlText ||
                      undefined
                    : undefined
                }
                href={itemUrl ?? '#'}
                target={item?.urlTarget ?? '_self'}
              >
                {item?.urlText}
              </S.Links>
              <S.Chevron data-test-id='CtaChevron' height={22} />
            </S.LinksBox>
          </S.Navigations>
        );
      })}
    </S.Wrapper>
  );
};
